import "./style.scss";
import React, { useState } from "react";
import Button from "@mui/material/Button";
import { Area, Point } from "react-easy-crop/types";
import Cropper from "react-easy-crop";
import { getCroppedImg } from "../Utils/canvasUtils";

interface IImageCropDialogProps {
    aspect?: any;
    handleCancel: () => void;
    imageUrl: string;
    setBuffer: (buffer: any) => void;
    setCroppedImageFor: (croppedImageUrl: string) => void;
    cropShape?: "rect" | "round";
}

const ImageCropDialog: React.FC<IImageCropDialogProps> = ({
    aspect = 1 / 1,
    handleCancel,
    imageUrl,
    setBuffer,
    setCroppedImageFor,
    cropShape,
}) => {
    const [zoom, setZoom] = useState(1);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [croppedAreaPixels, setCroppedAreaPixels] = useState<Area | null>(
        null
    );
    const handleCropChange = (crop: Point) => {
        setCrop(crop);
    };

    const handleZoomChange = (zoom: number) => {
        setZoom(zoom);
    };

    const handleCropComplete = (_: Area, croppedAreaPixels: Area) => {
        setCroppedAreaPixels(croppedAreaPixels);
    };

    const handleSave = async () => {
        const { getBlobData, getFormData } = await getCroppedImg(
            imageUrl,
            croppedAreaPixels
        );

        const blobData = await getBlobData();

        setBuffer(getFormData);
        setCroppedImageFor(blobData);
    };

    return (
        <div className="crop-dialog-container">
            <div className="backdrop" onClick={handleCancel}></div>
            <div className="crop-container">
                <Cropper
                    image={imageUrl}
                    zoom={zoom}
                    crop={crop}
                    onCropChange={handleCropChange}
                    onZoomChange={handleZoomChange}
                    onCropComplete={handleCropComplete}
                    aspect={aspect}
                    showGrid={false}
                    objectFit="contain"
                    cropShape={cropShape}
                />
            </div>
            <div className="controls">
                <div className="button-area">
                    <Button color="secondary" onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSave}
                    >
                        Save
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ImageCropDialog;
